
import { defineComponent, onMounted, ref, toRef, watch } from "vue";
import StepsProgress from "../../views/dashboard/components/steps-progress.vue";
import { List as AccountList } from "@/core/services/consensu/accounts";
import { useStore } from "vuex";
import Pagination from "../pagination/index.vue";
// import Dropdown2 from "@/components/dropdown/Dropdown2.vue";

export default defineComponent({
  name: "SitesTableNew",

  components: {
    Pagination,
    StepsProgress,
  },

  props: {
    widgetClasses: String,
    filter: String,
    limit: {
      type: Number,
      default: 10,
    },
    actions: {
      type: Boolean,
      default: true,
    },
    havePagination: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const store = useStore();
    const page = ref(1);
    const limit = toRef(props, "limit");
    const filter = toRef(props, "filter");
    const result = ref({
      totalDocs: 0,
    });
    const tableRows: any = ref([]);
    const owner: string = store.getters.currentUser._id;

    watch(filter, async (filter) => {
      getData(filter);
    });

    const newPage = (payload) => {
      page.value = payload.page;
      getData();
    };

    const getData = async (filter = "") => {
      let accountList = await AccountList(owner, {
        page: page.value,
        limit: limit.value,
        query: filter,
      });

      result.value = accountList;
      tableRows.value = accountList ? accountList.docs : [];
    };

    onMounted(() => {
      getData();
    });

    return {
      page,
      result,
      tableRows,
      owner,
      newPage,
    };
  },

  methods: {
    initials(item) {
      return item
        .match(/(^\S\S?|\b\S)?/g)
        .join("")
        .match(/(^\S|\S$)?/g)
        .join("")
        .toUpperCase();
    },

    getBadgeLabel(label) {
      return label == "active" ? "Ativo" : "Desativado";
    },
  },
  computed: {
    total() {
      return this.result.totalDocs || 0;
    },
  },
});
